import { SET_SUCCESS_ORDER_ID, CLEAR_SUCCESS_ORDER_ID } from "../actions";

export default function setSuccessOrderID(state = "", action) {
  switch (action.type) {
    case SET_SUCCESS_ORDER_ID:
      return action.payload;
    case CLEAR_SUCCESS_ORDER_ID:
      return [];
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/successOrderID.js